export default __webpack_public_path__ + "static/illustration-canada.url-bc8ac17005b6323c6fc8f154bc83afd0.svg";